import { ON_MEETING } from '@/router/router';
import { RouteLocationNormalizedLoaded } from 'vue-router';

export const isMeetingRoute = ({ name }: RouteLocationNormalizedLoaded) =>
  name === ON_MEETING;
